import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, send_temp_password, verify_temp_password } from '../api/auth_api';

const MAX_ATTEMPTS = 3;

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPasswordField, setShowPasswordField] = useState(false);
    const [tempPassword, setTempPassword] = useState('');
    const [attempts, setAttempts] = useState(0);
    const [passwordVerified, setPasswordVerified] = useState(false);
    const navigate = useNavigate();

    const resetForm = () => {
        setEmail('');
        setMessage('');
        setError('');
        setLoading(false);
        setShowPasswordField(false);
        setTempPassword('');
        setAttempts(0);
        setPasswordVerified(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!showPasswordField) {
            setLoading(true);
            try {
                const response = await send_temp_password(email);
                setMessage(response.message);
                setShowPasswordField(true);
                setAttempts(0);
            } catch (err) {
                const serverMessage = err.response?.data?.message || 'קרתה שגיאה בשליחת הסיסמה. נסה שוב מאוחר יותר.';
                setError(serverMessage);
                resetForm(); // שגיאה בשלב שליחת הסיסמה => תמיד חוזרים להתחלה
            } finally {
                setLoading(false);
            }
        } else {
            // בשלב אימות הסיסמה
            try {
                const response = await verify_temp_password(email, tempPassword);
                setMessage(response.message || 'הסיסמה אומתה בהצלחה!');
                setPasswordVerified(true);
                console.log("forgot password", email);
                navigate('/change_password', { state: { email, fromVerification: true } });
            } catch (err) {
                const serverMessage = err?.response?.data?.message || '';
                const statusCode = err?.response?.status;
                console.log(serverMessage);
                if (statusCode === 401) {
                    const newAttempts = attempts + 1;

                    if (newAttempts >= MAX_ATTEMPTS) {
                        setError('חרגת ממספר הניסיונות. נא לשלוח שוב סיסמה זמנית.');
                        resetForm();
                    } else {
                        setAttempts(newAttempts);
                        setError('סיסמה שגויה, נסה שוב.');
                    }
                } else {
                    const fallback = 'קרתה שגיאה באימות הסיסמה. נסה שוב מאוחר יותר.';
                    setError(serverMessage || fallback);
                    resetForm();
                }
            }
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit} className="login-form">
                <h2 className="login-title">איפוס סיסמה</h2>
                <p>יש להזין את כתובת האימייל שלך ונשלח לך סיסמה זמנית</p>

                <div className="form-group">
                    <label>אימייל</label>
                    <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={showPasswordField}
                    />
                </div>

                {showPasswordField && !passwordVerified && (
                    <div className="form-group">
                        <label>סיסמה זמנית</label>
                        <input type="text" value={tempPassword} onChange={(e) =>
                            setTempPassword(e.target.value.replace(/\D/g, '').slice(0, 6))}
                            inputMode="numeric" maxLength={6} required
                        />

                    </div>
                )}

                <button type="submit" className="connect-btn" disabled={loading}>
                    {loading
                        ? 'טוען...'
                        : !showPasswordField
                            ? 'שלח סיסמה זמנית'
                            : 'אמת סיסמה זמנית'}
                </button>

                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
            </form>
        </div>
    );
};

export default ForgotPassword;
